import { Violation } from "utils/dataAccess";

type Element = {
  id: string;
  name: string;
  children?: Element[];
};

/**
 * Groups validation errors by form element ID
 * @param violations - list of validation errors from the API
 * @param elements - structure of form fields
 * @returns object in the form { [elementId]: string[] }
 */
export function mapViolationsToFields(
  violations: Violation[],
  elements: Element[]
): Record<string, string[]> {
  return violations.reduce((acc: Record<string, string[]>, violation) => {
    const cleanPath = violation.propertyPath.replace(/^[^\]]+\[\d+\]\./, '');

    const elementId =
      elements.find((e) => e.name === cleanPath)?.id ??
      elements.flatMap((e) => e.children || []).find((c) => c.name === cleanPath)?.id ??
      cleanPath;

    if (!acc[elementId]) {
      acc[elementId] = [];
    }

    acc[elementId].push(violation.message);

    return acc;
  }, {});
}